import { render, staticRenderFns } from "./TraineeSponsorPostulations.vue?vue&type=template&id=6eaf3172&"
import script from "./TraineeSponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./TraineeSponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports